import axios from "axios";
import baseUrl from "@/api";
import { useLocationStore } from "@/stores/location";

const axiosClient = axios.create({
  baseURL: baseUrl,
});

// 🔥 Interceptor GLOBAL para sucursal
axiosClient.interceptors.request.use((config) => {
  const locationStore = useLocationStore();

  // Asegurar params
  if (!config.params) {
    config.params = {};
  }

  // ✅ SOLO enviar location_id
  // ❌ EXCEPTO en checkout
  if (
    locationStore.selectedStore?.id &&
    !config.url.includes("/shopify/checkout")
  ) {
    config.params.location_id = locationStore.selectedStore.id;
    // 👆 gid://shopify/Location/XXXX
  }

  return config;
});

export default axiosClient;
